import client, { TOKEN_KEY } from './client';

export async function login(email: string, password: string): Promise<any> {
  const res = await client.post('/api/auth/login', { email, password });
  return res.data;
}

export function logout(): void {
  localStorage.removeItem(TOKEN_KEY);
}
